import { provideState } from '@ngrx/store';

import { subscriptionsCheckupFeature } from './subscriptions-checkup.reducer';

export const subscriptionsCheckupStore = [
  provideState(subscriptionsCheckupFeature),
];
